import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, FormLayout, TextField, Button, Card, Select, Layout, ResourceList,ResourceItem, Avatar, PageActions, Modal, Thumbnail, Icon, VisuallyHidden } from '@shopify/polaris';
import { BasicTextField } from '@presentational';
import { TickMinor } from '@shopify/polaris-icons'
import { tAttribute } from '@utils';
import isEmpty from 'lodash/isEmpty'

const propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  weightUnits: PropTypes.array.isRequired,
  baseVariantsURL: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  productOptions: PropTypes.array.isRequired,

  status: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};


const VariantForm = ( props ) => {
  let sharedFieldProps = {
    handleChange: props.handleChange,
    values: props.values,
    errors: props.errors
  }
  console.log("VariantForm", props);

  const pImagesPresent = (props.product.images && !isEmpty(props.product.images));

  return(
    <Layout>
      {/* Left Section */}
      <Layout.Section secondary>
        <Card>
          <Card.Section>
            <div className="flex flexRow">
              { pImagesPresent ?
                <Thumbnail source={ props.product.images[0].url }  size="medium" />
                :
                <Avatar size="large" customer={false} initials={props.product.title.charAt(0)} />
              }
              <div className="ml10">
                <h4>
                  { props.product.title }
                </h4>
                <h5>
                  { props.variants.length } variants
                </h5>
              </div>
            </div>
          </Card.Section>
        </Card>

        <Card title={ I18n.t("activerecord.models.variant.other") }>
          <ResourceList
            items={props.variants}
            renderItem={(variant) => {
              const {id, image } = variant;
              const media = (image && image.url) ? <Thumbnail source={ image.url }  size="small" />  : <Avatar size="medium" customer={false} initials={variant.title.charAt(0)} />;
              const selected = props.values.id == id;

              return (
                <div className={ selected ? "variantListItem selected" : "variantListItem" }>
                  <ResourceItem
                    id={id}
                    url={ selected ? null : `${props.baseVariantsURL}/${id}/edit`}
                    media={media}
                  >
                    <h3>
                      { variant.title }
                    </h3>
                  </ResourceItem>
                </div>
              );
            }}
          />
        </Card>
      </Layout.Section>

      {/* Right section */}
      <Layout.Section>
        <Form onSubmit={props.handleSubmit}>
          <FormLayout>

            <Card title={ I18n.t("shopify.options") }>
              <Card.Section>
                { props.productOptions.map( (option,index) =>
                  <div className={ index != 0 ? "mt10" : ""} key={index}>
                    <BasicTextField
                      name={`selected_options.${index}`}
                      label={ option.name }
                      {...sharedFieldProps}
                      error={ props.errors && props.errors.selected_options }
                      value={ props.values.selected_options && props.values.selected_options[index] }
                    />
                  </div>
                )}

                <VisuallyHidden>
                  <BasicTextField
                    disabled={true}
                    name="title"
                    type="text"
                    {...sharedFieldProps}
                    value={props.values.title= props.values.selected_options === null ? "": props.values.selected_options.join(" • ") }
                  />
                </VisuallyHidden>
              </Card.Section>
            </Card>

            <Card title={ I18n.t("shopify.pricing") }>
              <Card.Section>
                <FormLayout>
                  <FormLayout.Group>
                    <BasicTextField
                      name="price"
                      type="number"
                      min="0"
                      label={tAttribute("variant", "price")}
                      {...sharedFieldProps}
                      readOnly={ !props.isAdmin }
                    />
                    <BasicTextField
                      name="unit_cost"
                      type="number"
                      min="0"
                      label={tAttribute("variant", "unit_cost")}
                      {...sharedFieldProps}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
            </Card>

            <Card title={ I18n.t("shopify.inventory") }>
              <Card.Section>
                <FormLayout>
                  <FormLayout.Group>
                    <BasicTextField
                      name="sku"
                      label={tAttribute("product", "sku")}
                      {...sharedFieldProps}
                    />
                    <BasicTextField
                      name="barcode"
                      label={tAttribute("product", "barcode")}
                      {...sharedFieldProps}
                    />
                  </FormLayout.Group>
                </FormLayout>
              </Card.Section>
            </Card>

            <Card title={ I18n.t("shopify.organization") }>
              <Card.Section>
                <BasicTextField
                  name="weight"
                  type="number"
                  min="0"
                  label={tAttribute("variant", "weight")}
                  {...sharedFieldProps}
                  connectedRight={
                    <Select
                      id="weight_unit"
                      onChange={props.handleChange}
                      value={ props.values.weight_unit }
                      label="Weight unit" labelHidden options={ props.weightUnits } />
                  }
                />
              </Card.Section>
            </Card>

            <Card title={ I18n.t("activerecord.attributes.variant.image") }>
              <Card.Section>
                <div className="variantImageSelections flex flexWrap">
                  { pImagesPresent && props.product.images.map( (imgInfo, index) => {
                    const { id, url } = imgInfo;
                    const selected = (props.values.image && props.values.image.id) == imgInfo.id;
                    return(
                      <div className={`imageOption mr10 ${selected ? 'selected' : ''}`} key={ index }>
                        <Button
                          onClick={ () => props.setFieldValue("image", imgInfo) }
                          outline>
                          <Thumbnail
                            source={ url }
                            size="large"
                          />
                          { selected &&
                            <div className="selectedIcon">
                              <Icon
                                color="blueLight"
                                source={TickMinor} />
                            </div>
                          }
                        </Button>
                      </div>
                    )
                  }
                  )}
                </div>
              </Card.Section>
            </Card>

            <PageActions
              primaryAction={{
                content: 'Save',
                loading: props.status.submitLoading,
                onAction: props.handleSubmit
              }}
              secondaryActions={ props.update ? [
                {
                  content: 'Delete',
                  destructive: true,
                  onAction: props.handleDelete,
                },
              ] : null }
            />
          </FormLayout>
        </Form>
      </Layout.Section>

    </Layout>
  )
}


VariantForm.propTypes = propTypes;


export default VariantForm;
